angular
	.module('WizApp')
	.service('UserService', [
        '$filter',
        '$http',
        'WizDataService',
        function ($filter, $http, WizDataService) {
            var route = $filter('route');

            return {
                Session: { slug: '' },

                get: function () {
                    var self = this;
                    var data = WizDataService.get('UserSession');

                    if (angular.isObject(data)) {
                        self.Session = data;
                        self.Session.avatar = angular.isString(self.Session.avatar) && self.Session.avatar.length > 0;
                        self.Session.displayName = self.Session.first_name + ' ' + self.Session.last_name;
                    }
                },

                resendConfirmationEmail: function () {
                    var url = route('wizbii_profileui_configuration_resendconfirmationmail');
                    return $http.get(url);
                },

                getVisitsOlderThan: function (offset) {
                    var url = route('wizbii_profileui_visit_loadvisits', { offset: offset });
                    return $http.get(url);
                },

                getNotificationsOlderThan: function (offset) {
                    var url = route('wizbii_profileui_notification_loadnotifications', { offset: offset });
                    return $http.get(url);
                }
            };

        }
    ])
;
